export default __webpack_public_path__ + "static/tag-dont-3-dark-3c74b9174a2bc9ed908ee193ad8644a8fc22108c03ac20ea7569044021eefbfa.png";